import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { PartesService } from '../../services/partes.services';

/**
 * Generated class for the VariedadesDetallePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-variedades-detalle',
  templateUrl: 'variedades-detalle.html',
})
export class VariedadesDetallePage {
  item = {id : null, Nombre : null};
  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, public partesService : PartesService) {
    if(navParams.data.item != 0){ 
      this.item = navParams.data.item;
    }
  }

  //Añadir Variedad
  addVariedad(){
    this.partesService.addVariedad(this.item);
    this.navCtrl.pop();
  } 

  //Borrar Variedad
  deleteVariedad(){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar esta Variedad?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
               this.partesService.deleteVariedad(this.item);
               this.navCtrl.pop();
           }
        }
      ]
    });
    alert.present();
  }  

  ionViewDidLoad() {
    console.log('ionViewDidLoad VariedadesDetallePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/variedades-detalle/variedades-detalle.ts